var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretDown = function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-3 -3 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 9.274a.56.56 0 0 1-.794 0l-3.753-3.75a.562.562 0 0 1 .795-.795l3.351 3.352 3.354-3.354a.562.562 0 0 1 .795.795z"
  })));
};
export default SvgCaretDown;